import React from 'react'

const CompanyAssignAssesment = () => {
  return (
    <div>
      under construction
    </div>
  )
}

export default CompanyAssignAssesment
